const getInitials = (name: string): string =>
  name
    .split(' ')
    .map((word) => word.charAt(0))
    .join('')
    .toUpperCase();

export { getInitials };
